/**
 * Caducidad de la sync de catálogo. Onnautic publica cada varios días;
 * el resto se considera viejo a las 48 h. La misma regla la usa el catálogo
 * y el inicio de la tienda.
 */

export function catalogSyncStaleMaxHours(supplierSlug: string): number {
    return supplierSlug.trim().toLowerCase() === 'onnautic' ? 24 * 8 : 48;
}

export function isStaleSync(
    lastSyncedAt: string | null | undefined,
    hours = 48,
    nowMs: number = Date.now(),
): boolean {
    if (!lastSyncedAt) return true;
    const syncedAt = new Date(lastSyncedAt).getTime();
    if (!Number.isFinite(syncedAt)) return true;
    return nowMs - syncedAt > hours * 3_600_000;
}
